/** @lint */

/**
 * @module orb/features/nav
 */
define('orb/nav', [
  'orb/features/_drawerManager',
  'orb/features/masthead/_drawer',
], function (drawerManager, Drawer) {
  'use strict';

  var api = {
    loadCss: function (url, callback) {
      window.bbcpage.loadCSS(url).then(function() {
        if (typeof callback == 'function') {
          callback();
        }
      });
    },

    loadJs: function (url) {
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = url;
      script.async = true;
      document.getElementsByTagName('body')[0].appendChild(script);
    },

    addDrawer: function (panelName, control, content, stateChangeCallback) {
      var drawerElement = document.getElementById('orb-panels');
      drawerElement.appendChild(content);

      var panel = new Drawer.Panel(
        panelName,
        { control: control, content: content },
        stateChangeCallback
      );
      drawerManager.getMastheadDrawer().addPanel(panel);
      drawerManager.addPanelEvents(panel);
    },

    getDrawerState: function (panelName) {
      var drawer = drawerManager.getMastheadDrawer(),
        currentPanel = drawer.getCurrentPanel();

      return currentPanel === null || currentPanel.name != panelName
        ? 'hidden'
        : 'shown';
    },

    updateDrawerHeight: function (panelName) {
      // This API appears to be called a fair amount by the notifications
      // web module.  Essentially it force-resized the drawer to match the
      // size of the content that was being displayed.
      //
      // Since commit b9fad8f206a2fd53011a8e57a9e6491365721cbb however, an
      // update was made to push the responsibility of the drawer's height
      // back up to the browsers' CSS box model by setting the `display`
      // property to `inline` when the drawer's open animation completes
      //
      // When `inline` is applied, the browser ignores the `height`
      // property and sizes the box according to the content that is inside
      // it; e.g. it will make the box bigger/smaller according to the
      // contents of its children.
      //
      // Reading the source of the notifications code, one might reason
      // this is what the notifications team want to happen as they call
      // the updateDrawerHeight function in response to their components
      // completing the render.
      //
      // I therefore nop out this function because not only is it
      // redundant, but it also causes visual UI blips when executed in
      // parallel to a drawer animation.
      //
      // I think function was a really good example of exposing the guts of
      // Orbit in reaction to a bug, as opposed to fixing the bug that was
      // within Orbit itself.
    },

    getMastheadDrawer: function () {
      return drawerManager.getMastheadDrawer();
    },

    refresh: function () {
      // This is effectively a no-op since we are now able to use MutationObserver to refresh the
      // nav in according to changes.
    },
  };

  document.getElementById('orb-header').addEventListener('orbit-drawer-open', function() {
    // Someone has opened a drawer via new 'orbit-drawer' module
    // If we have one open, time to close it!
    drawerManager.getMastheadDrawer().hidePanel();
  });


  return api;
});
